module.exports = __webpack_public_path__ + "img/avatar.d38af25c.jpg";